exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cloud-provider-logo .icon-cf {\n  background: url(" + require("./cf.logo.svg") + ") no-repeat 50% 50%;\n  background-size: cover;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/cloudfoundry/logo/cf.logo.less
// module id = 3973
// module chunks = 0